import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { reportDTO } from "./api-interfaces/api-reports-interface";
import { reportIncadea } from "./api-interfaces/api-interface-incadea-reports";
import { HelperService } from "../helperService";


@Injectable({
    providedIn: 'root'
})

export class APIReportServiceIncadea {
    ApiURL: string = "";
    constructor(private http: HttpClient, public helperService: HelperService) {
        this.ApiURL = environment.ReportUrl + 'Reports/';
    }

    public getReportsFilterDropDownIncadeaReport(roleId:number): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const url =
          `${this.ApiURL}GetReportIncadea/${roleId}`

        const requestOptions = {
            headers: headers,
          };
        return this.http.get(url, requestOptions);
    }

    public getReportsFilterDropDownIncadea(roleId:number,countryId: number, secondId?: string, thirdId?: string, fourthId?: string): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        let diccionary=
        {
            "@proleId": String(roleId),
            "@pcountryId": String(countryId),
            "@pcompanyId": (secondId? secondId : null),
            "@plocationId": (thirdId? thirdId : null),
            "@pdepartmentCode": (fourthId? fourthId : null),
          }
         const url =
        `${this.ApiURL}GetFilterReportsIncadea`

        const requestOptions = {
          headers: headers,
        };
         return this.http.post(url,diccionary, requestOptions);
  }


    public post(roleId:number,ReportId:number,isExport:number, isIncadea:number, parameters:reportIncadea):Observable<any> {
        //  return this.http.post(`${this.ApiURL}GetReport?roleid=${roleId}&reportid=${ReportId}&isExport=${isExport}`,isExport===0? parameters:parameters,  {responseType:'blob'})
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const url = `${this.ApiURL}GetReport?roleid=${roleId}&reportid=${ReportId}&isExport=${isExport}&isIncadea=${isIncadea}`

        if (isExport===0) {
            const requestOptions = {
              headers: headers,
            };
            return this.http.post(url, parameters, requestOptions)
        }
        else {
            const requestOptions = {
              headers: headers,
              responseType:'blob' as 'json'
            };
            return this.http.post(url, parameters, requestOptions)
        }
    }




}
